// src/services/produtos/ProdutoVariacaoService.js
import { fetchData, postData, putData, deleteData } from '../Api';
export const buscarProdutoVariacoes = produtoId => fetchData('/ProdutoVariacao', { produtoId });
export const adicionarProdutoVariacao = ({ produtoId, variacaoId }) => postData('/ProdutoVariacao', { produtoId:Number(produtoId), variacaoId:Number(variacaoId) });
export const alterarProdutoVariacao = ({ id, produtoId, variacaoId }) => putData('/ProdutoVariacao', { id, produtoId, variacaoId });
export const excluirProdutoVariacao = id => deleteData('/ProdutoVariacao', { id });
export const copiarProdutoVariacoes = async (produtoId, vinculos) => {
  for (const vinculo of vinculos || []) await adicionarProdutoVariacao({ produtoId, variacaoId:vinculo.variacaoId });
  return buscarProdutoVariacoes(produtoId);
};
